



































import Clock from "@/components/Clock.vue";
import ConfirmButton from "@/components/ConfirmButton.vue";
import {Component, Vue} from "vue-property-decorator";

interface ClockQuiz{
 hour: number;
 min: number;
 status: string;
}

@Component({
  components: {ConfirmButton, Clock}
})
export default class ClockCount extends Vue {

  questions: Array<ClockQuiz> = [];
  step = 0;
  answer = {
    hour: '',
    min: ''
  };
  status = '';
  modalShow = false;

  get currentQuiz(): ClockQuiz {
    return this.questions[this.step] || {hour: 0, min: 0, status: ''};
  }

  get isComplete(): boolean {
    return (this.step + 1) === this.questions.length;
  }

  /**
   * 메소드
   */

  randomElement(array: Array<number>): number {
    return array[Math.floor(Math.random() * array.length)]
  }

  quizGenerate(): void {
    this.questions.push({
      hour: this.randomElement([1,2,3,4,5,6,7,8,9,10,11,12]),
      min: this.randomElement([5,10,15,20,25,30,35,40,45,50,55,60]),
      status: ''
    })
  }

  cleanUpQuizzes(): void {
    this.questions.map((que, idx)=>{
      this.$delete(this.questions, idx);
    })

  }

  checkAnswer(): void {
    if (!this.answer.min) {
      this.answer.min = '0';
    }

    const isCurrect =
        parseInt(this.answer.hour) === this.currentQuiz.hour &&
        parseInt(this.answer.min) === this.currentQuiz.min;

    if (isCurrect) {
      this.questions[this.step].status = 'good';
    } else {
      this.questions[this.step].status = 'bad';
    }
    this.modalShow = true;
  }

  nextStep(): void {

    this.modalShow = false;

    this.$nextTick(() => {
      if ((this.step + 1) >= this.questions.length) {
        this.$buefy.dialog.alert('모두 풀었어요!')
        return;
      }
      this.answer.hour = '';
      this.answer.min = '';
      this.step += 1;
    })

  }
  async initialize(): Promise<boolean> {
    return new Promise(( (resolve): void => {
      for (let i = 0; i < 10; i++) {
        this.quizGenerate();
      }
      resolve(true);
    }))
  }
  mounted(): void {
    this.initialize();
  }
}
